export const TENANT_PORTAL_SERVICE_NUMBER = '+43 5 75 75 3700';
export const CUSTOMER_PORTAL_WEB = 'https://www.wienerwohnen.at';
